module.exports = __webpack_public_path__ + "img/synopsis3.da20339.svg";